import GetOptOut from "./GetOptOut"

const GetOptOutRequest = {
	GetOptOut,
}

export default GetOptOutRequest;